import { Breadcrumb, Container } from "react-bootstrap";
import { Outlet, useLocation } from "react-router-dom";
import { CTeDto, getLocal, isCteComplementoValores, STORAGECTE_KEY } from "../CTe.Dto";

const CTeCadastroView = () => {
  const { pathname } = useLocation();

  const cte = getLocal<CTeDto>(STORAGECTE_KEY);
  const complemento = isCteComplementoValores(cte?.tipoCte);

  const allSteps = [
    { label: "Características", path: `/fiscal/cte/cadastro/caracteristicas` },
    { label: "Percurso", path: `/fiscal/cte/cadastro/percurso` },
    { label: "Tributação", path: `/fiscal/cte/cadastro/tributacao` },
    { label: "Remetente", path: `/fiscal/cte/cadastro/remetente` },
    { label: "Destinatário", path: `/fiscal/cte/cadastro/destinatario` },
    { label: "Carga", path: `/fiscal/cte/cadastro/carga` },
    { label: "Valores", path: `/fiscal/cte/cadastro/valores` },
    { label: "Documentos", path: `/fiscal/cte/cadastro/documentos` },
    { label: "Finalização", path: `/fiscal/cte/cadastro/finalizacao` },
  ];

  // Complemento de valores não possui carga nem documentos transportados
  const steps = complemento
    ? allSteps.filter((s) => !/\/(carga|documentos)$/.test(s.path))
    : allSteps;

  const currentIndex = steps.findIndex((s) => pathname.startsWith(s.path));
  const visibleSteps = steps.slice(0, currentIndex + 1);
  const ellipsisIndex = { label: "...", path: "ellipsis" };
  const showSteps =
    visibleSteps.length > 3
      ? [ellipsisIndex, ...visibleSteps.slice(-3)]
      : visibleSteps;

  return (
    <Container>
      <Breadcrumb className="mt-3">
        {showSteps.map((step) => {
          const isComplete = visibleSteps.indexOf(step) < currentIndex;

          if (step.path === "ellipsis") {
            return (
              <Breadcrumb.Item
                linkAs="span"
                key="ellipsis"
                active={false}
                className={isComplete ? "text-success" : ""}
              >
                ...
              </Breadcrumb.Item>
            );
          }

          const isActive = pathname === step.path;

          return (
            <Breadcrumb.Item
              key={step.path}
              linkAs="span"
              linkProps={isActive ? {} : { href: step.path }}
              active={isActive}
              className={isComplete ? "text-success" : ""}
            >
              {step.label}
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb>
      <Outlet />
    </Container>
  );
};

export default CTeCadastroView;
